

export class UserChangePasswordDto {
    userId!: string;
    oldPassword?: string;
    password!: string;
    confirmPassword!: string;
}